export default __webpack_public_path__ + "static/media/MARCLogo.94e00f58.png";